import { Autocomplete, ClickAwayListener, Divider, InputBase, Paper, TextField } from "@mui/material";
import { useEffect, useMemo } from "react";
import { useCargoStore } from "../../stores/rh/cargo";
import PrimaryButton from "../../common/components/primary_button";
import DynamicIcon from "../../common/components/dynamic_icon";

/**
 * CargoSelectNew
 */

interface Props {
  value: number | null
  onChange: (value: number | null) => void
  onNewCargo: () => void
  onOpen?: () => void
  required?: boolean
  erro?: boolean
  messageErro?: string
  disabled?: boolean
}

function CargoSelectNew({ value, onChange, onNewCargo, required = false, erro = false, messageErro = "", disabled = false, onOpen }: Props) {
  const { cargoResume, setCargoResume, loadingCargoResume, erroCargoResume, setErroCargoResume } = useCargoStore()

  useEffect(() => {
    if (cargoResume.length === 0) {
      setCargoResume()
    }
  }, [])

  const CustomPaper = useMemo(() => (({ onClick, children, ...props }: any) => (
    <Paper {...props}>
      <div>
        {children}
        <Divider />
        <div className="m-2">
          <div className="p-2 cursor-pointer rounded-[4px] font-semibold">
            <button type="button" className="text-sm text-primary-green" onMouseDown={onClick}>
              <DynamicIcon nameIcon="Add" size={20} className="text-primary-green" />
              <span>Novo Cargo</span>
            </button>
          </div>
        </div>
      </div>
    </Paper>
  )), []);

  return (
    <Autocomplete
      id="cargo-select"
      disabled={disabled}
      options={cargoResume}
      onOpen={async () => {
        if (onOpen) {
          onOpen()
        }
        if (cargoResume.length === 0) {
          await setCargoResume()
        } else {
          setErroCargoResume(false)
        }
      }}
      slots={{
        paper: CustomPaper,
      }}
      slotProps={{
        paper: {
          onClick: onNewCargo,
        }
      }}
      value={cargoResume.find((option) => option.idCargo === value) ?? null}
      getOptionLabel={(option) => option.descricao ?? "-"}
      onChange={(_, newValue) => {
        onChange(newValue?.idCargo ?? null)
      }}
      isOptionEqualToValue={(option, selectedOption) => option.idCargo === selectedOption.idCargo}
      getOptionKey={(x) => x.idCargo}
      filterSelectedOptions
      loading={loadingCargoResume}
      renderInput={(params) => (
        <TextField
          {...params}
          required={required}
          disabled={disabled}
          size="small"
          label="Cargo New"
          error={erroCargoResume || erro}
          helperText={erroCargoResume === true ? "Houve algum erro ao buscar os cargos" : (erro === true ? messageErro : "")}
        />
      )}
    />
  );
}

export default CargoSelectNew;